module.exports = ".wrap-statistic{\r\n    margin: 20px 0;\r\n}\r\n.wrap-buttons{\r\n    display: flex;\r\n    justify-content: space-around;\r\n}"